import { Paragraph } from '@/components/Paragraph';

import type { ItineraryProduct } from '@/types/products';

interface ProductDayToDayOtherProps {
  itineraryProduct: ItineraryProduct;
}

export function ProductDayToDayOther({ itineraryProduct }: ProductDayToDayOtherProps) {
  switch (itineraryProduct.type.toLowerCase()) {
    case 'transfer': {
      return (
        <Paragraph>
          Verhuurder: {itineraryProduct.Supplier.name} <br />
          Telefoon: <br />
          24h Road Assistence: <br />
          Reserveringsnummer:
        </Paragraph>
      );
    }
    case 'ferry':
    case 'accommodation': {
      const mealOption = itineraryProduct.ItineraryProductOptions?.find(
        (option) => option.type === 'mealplan' && option.selected,
      );

      return (
        <Paragraph>
          Verblijf: {itineraryProduct.Supplier.name} <br />
          Maaltijden: {mealOption?.name || 'Geen maaltijden inbegrepen'} <br />
          Telefoon: <br />
          Adres: {itineraryProduct.Supplier.location}
        </Paragraph>
      );
    }
    case 'excursion': {
      return (
        <Paragraph>
          Verhuurder {itineraryProduct.Supplier.name}: <br />
          Telefoon: <br />
          24h Road Assistence: <br />
          Reserveringsnummer:
        </Paragraph>
      );
    }
    case 'carrental': {
      return (
        <Paragraph>
          Verhuurder:{itineraryProduct.Supplier.name} <br />
          Telefoon: <br />
          24h Road Assistence: <br />
          Reserveringsnummer:
        </Paragraph>
      );
    }
    case 'flight': {
      return (
        <Paragraph>
          Airline: {itineraryProduct.Supplier.name} <br />
          Vluchtnummer: {itineraryProduct.flight?.flightNumber} <br />
        </Paragraph>
      );
    }
    default:
      return null;
  }
}
